export type { ProductionFigureProps } from './production-figure';
export * from './production-figure.routes';

export { default as ProductionFigure, default } from './production-figure';
